import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateDeleteStaffingAgencyPocByIdMutation, MutateDeleteStaffingAgencyPocByIdMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'
// import { staffingAgencyPocCreatedUpdatedByIdDocument } from '../useStaffingAgencyPocCreatedUpdatedById'

const document = graphql(/* graphql */`
  mutation mutateDeleteStaffingAgencyPocById($id: MongoID!) {
    cat {
      staffingAgencyPoc {
        deleteById(_id: $id) {
          recordId
        }
      }
    }
  }
`)

export type UseMutateDeleteStaffingAgencyPocByIdReturn = UseMutationResult<
MutateDeleteStaffingAgencyPocByIdMutation,
unknown,
MutateDeleteStaffingAgencyPocByIdMutationVariables
>

const useMutateDeleteStaffingAgencyPocById = (): UseMutateDeleteStaffingAgencyPocByIdReturn => {
  return useGraphMutation(document)
}

export { useMutateDeleteStaffingAgencyPocById, document as mutateDeleteStaffingAgencyPocByIdDocument }
